import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import Constants from "../../../utils/Constants";
import axios from "axios";
import SplashScreen from "../../../components/loader/SplashScreen/SplashScreen";

import { Export, Restart } from "@carbon/icons-react";
import SearchHead from "../../../components/custom/SearchHead";
import { useState } from "react";
import ReactPaginate from "react-paginate";

const Contact = () => {
  const [page, setPage] = useState(1);
  const [loader, Setloader] = useState(false);
  const [searchparam, setsearchparam] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const CallContactData = (page) => {
    return axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        page: page || 1,
        ...(searchparam ? { search: searchparam } : {}),
        ...(startDate ? { 'createdAt[gte]': startDate } : {}),
        ...(endDate ? { 'createdAt[lte]': endDate } : {}),
      },
      url: Constants.url + "contactus/list",
    }).then((res) => {
      return res.data.data;
    });
  };

  const {
    data: ContactData,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => CallContactData(page),
    queryKey: ["ContactData", page],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  const headers = [
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "mobileNo" },
    { label: "City", key: "city" },
    { label: "Province", key: "province" },
    { label: "Comments", key: "comments" },
  ];

  useEffect(() => {
    refetch();
  }, [searchparam , startDate , endDate]);

  const Refresh = () => {
    Setloader(true);
    refetch().then(() => {
      Setloader(false);
    });
  };

  return (
    <>
      {!isLoading && !loader ? (
        <div className="uk-grid" uk-grid="">
          <div className="uk-width-1-1">
            <SearchHead
              RefreshFunc={Refresh}
              headers={headers}
              CsvData={ContactData.getContacts}
              Filename={"Contact_data.csv"}
              setsearchparam ={setsearchparam}
              endpoint = 'contactus'
              searchparam = {searchparam}
              startDate = {startDate}
              endDate = {endDate}
              setStartdate = {setStartDate}
              setEndDate = {setEndDate}
            />
            <div className="analyticsTableWrp uk-overflow-auto ">
              <table className="uk-table uk-table-striped  ">
                <thead className="table-header-shadow ">
                  <tr>
                    <th>S.No</th>

                    <th>first Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Province</th>
                    <th>City</th>
                    <th className="uk-table-expand">Comment</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {ContactData.getContacts.map((item, index) => (
                    <tr key={index}>
                      <td>{(page - 1) * 100 + (index + 1)}</td>
                      <td>{item.firstName || "-"}</td>
                      <td>{item.lastName || "-"}</td>
                      <td>{item.email || "-"}</td>
                      <td>{item.phoneNo || "-"}</td>
                      <td>{item.province || "-"}</td>
                      <td>{item.city || "-"}</td>
                      <td  >{item.comments || "-"}</td>
                      <td>
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleString("en-US", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className=" paginationcard uk-card uk-card-default ">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.round(ContactData.totalRecords / 100)}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => setPage(e.selected + 1)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default Contact;
